module.exports = __webpack_public_path__ + "assets/img/2171591934007_.pic_hd.60319bed.jpg";